import styled from 'styled-components';

import { breakpoints, Col } from '@notino/react-styleguide-v20';

import { InputGroupWithButton } from '@sharedComponents/Inputs';

export const StyledVoucherWrapper = styled(Col)`
  padding: 0;
  margin-bottom: 1rem;
`;

export const StyledVoucherWithCode = styled.span`
  display: inline;
`;

export const StyledVoucherInput = styled(InputGroupWithButton)`
  width: 100%;
  margin-top: 0.325rem;

  @media (min-width: ${breakpoints.md}) {
    width: 18rem;
  }
`;
